import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfColor } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { OptsImage } from '../optsImage';
import { IItemCount } from '@educraft/base';
import { GUtil } from '../../pdf/gutil';
import { calcGridRects } from '../../pdf/board/grid';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/imageFilter';
import '../../pdf/draw/cut';

/**
 * Obrysy (Silhouettes) - Coloured-gradient silhouette cards
 *
 * Layout: Landscape A4, flexible grid (3-24 items, same grid as BackScreen).
 * Each image is processed through:
 *   1. Shadow filter → black silhouette (preserves alpha)
 *   2. Gradient filter → left-to-right colour gradient + vertical lighting
 *
 * Colour palette is picked randomly from 3 options each generation.
 *
 * Migrated from C# EduFrame.Img10.Generators.Obrysy
 */

const COLOR_PALETTES: [string, string][] = [
  ['#84dad9', '#d2cb6b'],
  ['#7cbfc3', '#fb945d'],
  ['#6a49fb', '#dd403e'],
];

export class Obrysy implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 3;
  }
  countMax(): number {
    return 24;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const page = pdf.addPage(true);
    const margin = PdfUnit.FromMillimeters(5);

    const count = Math.min(opts.list.length, this.countMax());
    const { rects } = calcGridRects(count, margin, PdfSize.A4H);

    const {random} = opts.data;
    const palette = COLOR_PALETTES[random.next(0, COLOR_PALETTES.length)];
    const colorLeft = PdfColor.fromHex(palette[0]).getRgb();
    const colorRight = PdfColor.fromHex(palette[1]).getRgb();

    const imgMargin = PdfUnit.FromMillimeters(3);

    for (let i = 0; i < rects.length; i++) {
      const rect = rects[i];
      const imgRect = new PdfRect(
        rect.x + imgMargin,
        rect.y + imgMargin,
        rect.width - 2 * imgMargin,
        rect.height - 2 * imgMargin
      );

      const shadow = await opts.list[i].image.toShadow(pdf);
      const gradient = await shadow.toGradient(pdf, colorLeft, colorRight);

      page.drawImageCenter(gradient, imgRect);
      page.drawRectangle(GUtil.cutPen, null, rect);
    }
  }
}
